// @ts-nocheck
(function () {
  const $$ = (sel, root) => Array.prototype.slice.call((root || document).querySelectorAll(sel));

  // Use theme's scroll lock (html[scroll-lock]{overflow:hidden}) with a small ref-count.
  function setScrollLock(shouldLock) {
    const root = document.documentElement;
    const raw = root.getAttribute('data-scroll-lock-count');
    const current = Math.max(0, parseInt(raw || '0', 10) || 0);

    if (shouldLock) {
      const next = current + 1;
      root.setAttribute('scroll-lock', '');
      root.setAttribute('data-scroll-lock-count', String(next));
      return;
    }

    if (current === 0) return;
    const next = Math.max(0, current - 1);
    if (next === 0) {
      root.removeAttribute('data-scroll-lock-count');
      root.removeAttribute('scroll-lock');
    } else {
      root.setAttribute('data-scroll-lock-count', String(next));
    }
  }

  function prefersReducedMotion() {
    return (
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function navigationType() {
    try {
      const navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      const nav = navEntries && navEntries[0];
      if (nav && typeof nav.type === 'string') return nav.type;
    } catch (e) { /* ignore */ }
    const legacy = performance && performance.navigation;
    if (legacy && typeof legacy.type === 'number') {
      if (legacy.type === 1) return 'reload';
      if (legacy.type === 2) return 'back_forward';
      return 'navigate';
    }
    return 'navigate';
  }

  function samePathReferrer() {
    const ref = document.referrer;
    if (!ref) return false;
    try {
      const refUrl = new URL(ref);
      return refUrl.origin === window.location.origin && refUrl.pathname === window.location.pathname;
    } catch (e) { return false; }
  }

  function shouldRunOnThisLoad() {
    const type = navigationType();
    if (type === 'reload') return true;
    if (type === 'back_forward') return false;

    // Only relevant for the homepage.
    const isHomePage = document.body.classList.contains('is-home');
    if (!isHomePage) return false;

    // First-time direct entry (new tab / typed URL / external referrer) should run.
    const ref = document.referrer;
    if (!ref) return true;
    try {
      const refUrl = new URL(ref);
      if (refUrl.origin !== window.location.origin) return true;
      if (refUrl.pathname !== window.location.pathname) return true;
    } catch (e) { return true; }

    // Dev/browser fallback: refresh can be misreported as "navigate" but referrer stays same page.
    if (samePathReferrer()) return true;
    return false;
  }

  function clampInt(v, min, max, fallback) {
    const n = parseInt(String(v || ''), 10);
    if (isNaN(n)) return fallback;
    return Math.max(min, Math.min(max, n));
  }

  function mulberry32(seed) {
    let t = seed >>> 0;
    return function rand() {
      t += 0x6d2b79f5;
      let r = Math.imul(t ^ (t >>> 15), 1 | t);
      r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffleInPlace(arr, rand) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      const tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  function clamp01(n) { return Math.max(0, Math.min(1, n)); }

  // SVG scrim mask (avoids Safari/Firefox flicker from per-frame dataURL mask swaps)
  const SVG_NS = 'http://www.w3.org/2000/svg';
  function createSvgEl(tag) {
    return document.createElementNS(SVG_NS, tag);
  }

  function buildScrimSvg(scrimEl, overlayColor, rect) {
    while (scrimEl.firstChild) scrimEl.removeChild(scrimEl.firstChild);

    const maskId = 'homeRevealMask-' + Math.random().toString(36).slice(2);
    scrimEl.setAttribute('viewBox', '0 0 ' + rect.width + ' ' + rect.height);
    scrimEl.setAttribute('preserveAspectRatio', 'none');

    const defs = createSvgEl('defs');
    const mask = createSvgEl('mask');
    mask.setAttribute('id', maskId);
    mask.setAttribute('maskUnits', 'userSpaceOnUse');
    mask.setAttribute('x', '0');
    mask.setAttribute('y', '0');
    mask.setAttribute('width', String(rect.width));
    mask.setAttribute('height', String(rect.height));

    const base = createSvgEl('rect');
    base.setAttribute('x', '0');
    base.setAttribute('y', '0');
    base.setAttribute('width', String(rect.width));
    base.setAttribute('height', String(rect.height));
    base.setAttribute('fill', '#fff');

    const holes = createSvgEl('g');
    holes.setAttribute('fill', '#000');

    mask.appendChild(base);
    mask.appendChild(holes);
    defs.appendChild(mask);

    const scrimRect = createSvgEl('rect');
    scrimRect.setAttribute('x', '0');
    scrimRect.setAttribute('y', '0');
    scrimRect.setAttribute('width', String(rect.width));
    scrimRect.setAttribute('height', String(rect.height));
    scrimRect.setAttribute('fill', overlayColor);
    scrimRect.setAttribute('mask', 'url(#' + maskId + ')');

    scrimEl.appendChild(defs);
    scrimEl.appendChild(scrimRect);

    return { holes: holes };
  }

  function computeTilesLayout(overlayEl, cols, rows) {
    const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    const rect = overlayEl.getBoundingClientRect();
    const edgePad = isMobile ? 20 : 40;
    const gap = isMobile ? 6 : 8;

    const logoImg = overlayEl.querySelector('.c-home-reveal__overlay-logo-img');
    const logoH = Math.ceil(
      logoImg && logoImg.getBoundingClientRect ? logoImg.getBoundingClientRect().height : (isMobile ? 120 : 180)
    );
    const logoBottom = 14;
    const logoReserve = Math.max(logoBottom + logoH + 10, isMobile ? 120 : 160);

    const availW = Math.max(0, rect.width - edgePad * 2);
    const availH = Math.max(0, rect.height - edgePad - logoReserve - edgePad);

    const tileW = Math.floor((availW - gap * (cols - 1)) / cols);
    const tileH = Math.floor((availH - gap * (rows - 1)) / rows);

    return { rect: rect, isMobile: isMobile, edgePad: edgePad, logoReserve: logoReserve, cols: cols, rows: rows, tileW: tileW, tileH: tileH, gap: gap };
  }

  function setReady(el, overlayEl, instant) {
    el.classList.add('is-ready');
    document.body.classList.remove('home-reveal-running');
    document.body.classList.add('home-reveal-done');
    setScrollLock(false);
    if (overlayEl && overlayEl.parentNode) {
      if (instant) {
        overlayEl.parentNode.removeChild(overlayEl);
      } else {
        // Fade the solid pre-paint background out so there's no hard pop.
        overlayEl.style.transition = 'opacity 0.18s ease';
        overlayEl.style.opacity = '0';
        setTimeout(function () {
          if (overlayEl && overlayEl.parentNode) overlayEl.parentNode.removeChild(overlayEl);
        }, 190);
      }
    }
  }

  function initHomeRevealSection(el) {
    if (!el || el.__compoundHomeRevealInit) return;
    el.__compoundHomeRevealInit = true;

    const overlayEnabled = el.getAttribute('data-overlay-enabled') !== 'false';
    const overlayEl = el.querySelector('[data-compound-home-reveal-overlay]');
    const scrimEl = el.querySelector('[data-compound-home-reveal-scrim]');

    if (!overlayEnabled || !overlayEl || !scrimEl) {
      el.classList.add('is-ready');
      return;
    }

    // Theme editor: don't run the overlay animation.
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      setReady(el, overlayEl, true);
      return;
    }
    if (prefersReducedMotion()) {
      setReady(el, overlayEl, true);
      return;
    }
    if (!shouldRunOnThisLoad()) {
      // Navigation within the site — fade out the solid pre-paint cover.
      setReady(el, overlayEl, false);
      return;
    }

    // If the browser restored scroll position on reload, don't run the overlay mid-page.
    const initialScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    if (initialScrollY > 0) {
      setReady(el, overlayEl, false);
      return;
    }

    // During theme editor swaps / re-inits, don't replay.
    if (el.getAttribute('data-compound-home-reveal-ran') === 'true') {
      setReady(el, overlayEl, true);
      return;
    }
    el.setAttribute('data-compound-home-reveal-ran', 'true');

    setScrollLock(true);
    document.body.classList.add('home-reveal-running');
    document.body.classList.remove('home-reveal-done');

    const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    let cols = isMobile ? clampInt(el.getAttribute('data-overlay-cols-mobile'), 4, 14, 8) : clampInt(el.getAttribute('data-overlay-cols'), 6, 20, 12);
    let rows = isMobile ? clampInt(el.getAttribute('data-overlay-rows-mobile'), 4, 14, 10) : clampInt(el.getAttribute('data-overlay-rows'), 3, 14, 6);

    const overlayColor = el.getAttribute('data-overlay-color') || '#c70016';
    overlayEl.style.setProperty('--home-reveal-overlay-color', overlayColor);

    const scrimSvg = scrimEl;
    let rect = overlayEl.getBoundingClientRect();
    // Build the SVG scrim first (it immediately draws a full solid rect), then remove the
    // inline background so that tile holes correctly show the page content behind the overlay.
    let svgMask = buildScrimSvg(scrimSvg, overlayColor, rect);
    overlayEl.style.background = 'transparent';

    let layout = computeTilesLayout(overlayEl, cols, rows);
    rows = layout.rows;

    const total = cols * rows;
    const indices = [];
    for (let i = 0; i < total; i++) indices.push(i);
    const seed = Math.floor((performance.timeOrigin || Date.now()) % 2147483647);
    shuffleInPlace(indices, mulberry32(seed));

    const timeouts = [];
    let revealed = 0;
    const clearAllTimers = function () {
      timeouts.forEach(function (t) { clearTimeout(t); });
      timeouts.length = 0;
    };

    window.addEventListener('pageshow', function (e) {
      if (e && e.persisted) {
        clearAllTimers();
        setReady(el, overlayEl);
      }
    }, { once: true });

    overlayEl.classList.add('is-running');
    // Important: trigger logo/title animation AFTER initial paint.
    // With deferred section scripts, Safari/Firefox may apply `.is-logo` before first paint,
    // which means the "from" state never renders and the transition never runs.
    overlayEl.classList.remove('is-logo');
    requestAnimationFrame(() => {
      // eslint-disable-next-line no-unused-expressions
      overlayEl.offsetWidth;
      requestAnimationFrame(() => overlayEl.classList.add('is-logo'));
    });
    el.classList.add('is-overlay-running');

    const drawTileHole = function (lay, tileIndex) {
      const x = tileIndex % lay.cols;
      const y = Math.floor(tileIndex / lay.cols);
      const px = lay.edgePad + x * (lay.tileW + lay.gap);
      const py = lay.edgePad + y * (lay.tileH + lay.gap);
      const r = 8; // Fixed smaller border radius for the rectangular look

      const hole = createSvgEl('rect');
      hole.setAttribute('x', String(px));
      hole.setAttribute('y', String(py));
      hole.setAttribute('width', String(lay.tileW));
      hole.setAttribute('height', String(lay.tileH));
      hole.setAttribute('rx', String(r));
      hole.setAttribute('ry', String(r));
      svgMask.holes.appendChild(hole);
    };

    const REVEAL_MS = 2600;
    const EXIT_DELAY_MS = 100;
    const OVERLAY_REMOVE_MS = 550;
    const TILE_START_DELAY_MS = 200;
    const TILE_REVEAL_DURATION_MS = 2200;

    let raf = 0;
    let start = 0;
    let exiting = false;

    const rebuildMaskForResize = function () {
      rect = overlayEl.getBoundingClientRect();
      svgMask = buildScrimSvg(scrimSvg, overlayColor, rect);
      layout = computeTilesLayout(overlayEl, cols, rows);
      for (let i = 0; i < revealed; i++) drawTileHole(layout, indices[i]);
    };

    window.addEventListener('resize', rebuildMaskForResize, { passive: true });
    const vv = window.visualViewport;
    if (vv && vv.addEventListener) {
      vv.addEventListener('resize', rebuildMaskForResize, { passive: true });
      vv.addEventListener('scroll', rebuildMaskForResize, { passive: true });
    }

    const step = function (now) {
      if (!start) start = now;
      const elapsed = now - start;
      const tileElapsed = Math.max(0, elapsed - TILE_START_DELAY_MS);
      const p = clamp01(tileElapsed / TILE_REVEAL_DURATION_MS);
      if (!overlayEl.isConnected) return;

      const targetCount = Math.max(0, Math.min(indices.length, Math.floor(indices.length * p)));
      const end = Math.min(indices.length, targetCount);
      while (revealed < end) {
        drawTileHole(layout, indices[revealed]);
        revealed += 1;
      }

      if (p < 1) {
        raf = requestAnimationFrame(step);
        return;
      }

      if (!exiting) {
        exiting = true;
        timeouts.push(setTimeout(function () {
          overlayEl.classList.add('is-exiting');
          el.classList.add('is-ready');
          setScrollLock(false);
          document.body.classList.remove('home-reveal-running');
          document.body.classList.add('home-reveal-done');

          timeouts.push(setTimeout(function () {
            window.removeEventListener('resize', rebuildMaskForResize);
            if (vv && vv.removeEventListener) {
              vv.removeEventListener('resize', rebuildMaskForResize);
              vv.removeEventListener('scroll', rebuildMaskForResize);
            }
            if (overlayEl && overlayEl.parentNode) overlayEl.parentNode.removeChild(overlayEl);
            el.classList.remove('is-overlay-running');
          }, OVERLAY_REMOVE_MS));
        }, EXIT_DELAY_MS));
      }
    };

    raf = requestAnimationFrame(step);
    timeouts.push(setTimeout(function () {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    }, REVEAL_MS + EXIT_DELAY_MS + OVERLAY_REMOVE_MS + 500));
  }

  function ensureSwiper(cb) {
    if (window.Swiper) return cb();
    const interval = setInterval(() => {
      if (window.Swiper) {
        clearInterval(interval);
        cb();
      }
    }, 50);
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    $$('[data-compound-home-reveal]', scope).forEach((el) => {
      initHomeRevealSection(el);
      
      const swiperEl = el.querySelector('[data-compound-home-reveal-swiper]');
      if (swiperEl && !el.__compoundHomeRevealSwiperInit) {
        el.__compoundHomeRevealSwiperInit = true;
        
        ensureSwiper(() => {
          const autoplayEnabled = swiperEl.dataset.autoplay !== 'false';
          const autoplayDelay = parseInt(swiperEl.dataset.autoplayDelay || '5000', 10);
          
          const swiperConfig = {
            loop: true,
            speed: 800,
            observer: true,
            observeParents: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            allowTouchMove: true, // Enabled by default for swiping
          };

          if (autoplayEnabled) {
            swiperConfig.autoplay = {
              delay: autoplayDelay,
              disableOnInteraction: false,
            };
          }

          const swiper = new window.Swiper(swiperEl, swiperConfig);

          el.__compoundHomeRevealSwiper = swiper;
        });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  // Theme editor / async section loads
  document.addEventListener('shopify:section:load', (e) => {
    const target = e && e.target ? e.target : null;
    if (!target) return;
    init(target);
  });
})();

